<template>
  <div>
    <span class="title">{{ title }}</span>
    <b-form-group>
      <b-form-checkbox-group v-model="selected" :options="options" :stacked="stacked" disabled-field="disabled"
        @click.native="execute"></b-form-checkbox-group>
    </b-form-group>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "CheckboxGroup",
  props: {
    title: String,
    options: Array,
    params: Object,
    changed: Function,
    clicked: Function,
    initialValue: Array,
    value: Array,
    stacked: {
      type: Boolean,
      default: false,
    },
    markFormDirty: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selected: [],
    };
  },
  mounted() {
    if (this.initialValue) this.selected = this.initialValue;
  },
  methods: {
    ...mapMutations("validation", ["updateFormDirty"]),
    execute(event) {
      if (this.markFormDirty) this.updateFormDirty(true);
      this.$emit("input", this.selected);
      let self = this;
      setTimeout(function () {
        // adicionado o pointerId para prevenir que não seja executado em duplicidade
        if (self.clicked && event.pointerId === 1) self.clicked(self.params);
      }, 100);
    },
  },
  watch: {
    selected: {
      handler(value) {
        this.$emit("input", value);
        if (this.changed) this.changed(this.params);
      },
      deep: true,
    },
    initialValue: {
      handler(value) {
        if (this.initialValue) this.selected = this.initialValue;
      },
      deep: true,
    },
  },
};
</script>
